import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ArticleGridSection() {
  const { t } = useTranslation();

  const articles = [
    {
      tag: 'GUIDA',
      title: 'Itaobuy Spreadsheet: La Guida Completa per Principianti in Italiano',
      description: 'Scopri cos\'è Itaobuy Spreadsheet, come funziona e come utilizzarlo al meglio per trovare prodotti verificati e fare acquisti intelligenti.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20workspace%20with%20laptop%20displaying%20organized%20data%2C%20warm%20cream%20wooden%20desk%2C%20morning%20sunlight%20through%20sheer%20curtains%2C%20ceramic%20coffee%20cup%2C%20small%20plant%2C%20editorial%20productivity%20aesthetic%2C%20soft%20shadows%2C%20italian%20apartment%20vibe&width=800&height=600&seq=art-01-v2&orientation=landscape',
      link: '/articoli/guida-itaobuy-spreadsheet',
    },
    {
      tag: 'SICUREZZA',
      title: 'Itaobuy Spreadsheet è Sicuro? Analisi Completa e Consigli',
      description: 'Tutto quello che devi sapere sulla sicurezza di Itaobuy Spreadsheet: come verificare i prodotti, leggere le QC foto e proteggere i tuoi dati.',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20still%20life%20with%20a%20single%20padlock%20and%20key%20on%20smooth%20warm%20sand%20colored%20surface%2C%20dramatic%20side%20lighting%2C%20deep%20shadows%2C%20editorial%20security%20concept%2C%20warm%20beige%20and%20bronze%20tones%2C%20sophisticated%20trust%20theme&width=800&height=600&seq=art-02-v2&orientation=landscape',
      link: '/articoli/sicurezza-itaobuy-spreadsheet',
    },
    {
      tag: 'PRODOTTI',
      title: 'I Migliori Prodotti su Itaobuy Spreadsheet: Cosa Comprare nel 2026',
      description: 'Una selezione curata dei migliori prodotti disponibili su Itaobuy Spreadsheet: scarpe, abbigliamento, accessori e molto altro.',
      image: 'https://readdy.ai/api/search-image?query=Curated%20flat%20lay%20of%20premium%20fashion%20accessories%20on%20warm%20terracotta%20surface%2C%20sunglasses%20watch%20bracelet%20wallet%2C%20morning%20sunlight%20from%20left%2C%20shallow%20depth%20of%20field%2C%20luxury%20editorial%20style%2C%20warm%20gold%20and%20brown%20tones&width=800&height=600&seq=art-03-v2&orientation=landscape',
      link: '/articoli/prodotti-migliori-itaobuy',
    },
    {
      tag: 'GUIDA',
      title: 'Come Iniziare con Itaobuy Spreadsheet: Tutorial Passo Passo per Italiani',
      description: 'Un percorso guidato in 5 semplici passaggi per padroneggiare Itaobuy Spreadsheet e fare il tuo primo acquisto con sicurezza.',
      image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20beside%20a%20smartphone%20showing%20shopping%20interface%2C%20warm%20wooden%20table%2C%20cozy%20cafe%20setting%2C%20soft%20ambient%20light%2C%20hands-on%20learning%20aesthetic%2C%20warm%20inviting%20tones&width=800&height=600&seq=art-04-v2&orientation=landscape',
      link: '/articoli/guida-itaobuy-spreadsheet',
    },
    {
      tag: 'SICUREZZA',
      title: 'Guida alle QC Foto: Come Verificare la Qualità dei Prodotti',
      description: 'Impara a leggere e interpretare le immagini QC per assicurarti di ricevere esattamente ciò che hai ordinato. Guida pratica con esempi reali.',
      image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20detailed%20product%20photograph%20on%20warm%20desk%2C%20soft%20natural%20light%2C%20inspector%20quality%20control%20aesthetic%2C%20clean%20minimal%20composition%2C%20warm%20cream%20and%20dark%20wood%20tones%2C%20professional%20editorial&width=800&height=600&seq=art-05-v2&orientation=landscape',
      link: '/articoli/sicurezza-itaobuy-spreadsheet',
    },
    {
      tag: 'PRODOTTI',
      title: 'Scarpe su Itaobuy Spreadsheet: Guida alle Migliori Sneakers del 2026',
      description: 'Dalle sneakers alle scarpe sportive, scopri la selezione completa di calzature disponibili su Itaobuy Spreadsheet con prezzi e recensioni.',
      image: 'https://readdy.ai/api/search-image?query=Pair%20of%20trendy%20chunky%20sneakers%20on%20a%20white%20marble%20staircase%2C%20natural%20daylight%20from%20skylight%2C%20urban%20fashion%20editorial%2C%20dynamic%20angle%2C%20warm%20cream%20and%20white%20palette%2C%20modern%20sneakerhead%20aesthetic&width=800&height=600&seq=art-06-v2&orientation=landscape',
      link: '/articoli/prodotti-migliori-itaobuy',
    },
    {
      tag: 'GUIDA',
      title: 'Itaobuy Spreadsheet vs Ricerca Manuale: Quale Metodo Conviene?',
      description: 'Un confronto dettagliato tra l\'uso di Itaobuy Spreadsheet e la ricerca manuale tradizionale. Scopri perché lo spreadsheet vince su tutti i fronti.',
      image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20two%20different%20workspaces%2C%20one%20organized%20minimal%20the%20other%20cluttered%2C%20warm%20neutral%20palette%2C%20soft%20studio%20lighting%2C%20editorial%20productivity%20theme%2C%20clean%20modern%20aesthetic&width=800&height=600&seq=art-07-v2&orientation=landscape',
      link: '/articoli/guida-itaobuy-spreadsheet',
    },
    {
      tag: 'SICUREZZA',
      title: 'Errori da Evitare con Itaobuy Spreadsheet: Consigli degli Esperti',
      description: 'I 10 errori più comuni che gli acquirenti fanno e come evitarli. Consigli pratici basati sull\'esperienza di centinaia di utenti italiani.',
      image: 'https://readdy.ai/api/search-image?query=Red%20warning%20sign%20on%20a%20clean%20minimal%20desk%20setup%2C%20soft%20ambient%20light%2C%20subtle%20dramatic%20mood%2C%20editorial%20caution%20concept%2C%20warm%20beige%20with%20muted%20red%20accent%2C%20professional%20advisory%20aesthetic&width=800&height=600&seq=art-08-v2&orientation=landscape',
      link: '/articoli/sicurezza-itaobuy-spreadsheet',
    },
    {
      tag: 'PRODOTTI',
      title: 'Streetwear su Itaobuy Spreadsheet: Hoodie, Felpe e Tendenze Moda',
      description: 'Il meglio dello streetwear disponibile su Itaobuy Spreadsheet. Scopri le tendenze del momento e i capi più desiderati dagli appassionati di moda.',
      image: 'https://readdy.ai/api/search-image?query=Oversized%20graphic%20hoodie%20on%20a%20minimal%20concrete%20backdrop%2C%20urban%20street%20style%20editorial%2C%20harsh%20afternoon%20shadows%2C%20cool%20contemporary%20fashion%2C%20warm%20gray%20and%20cream%20tones%2C%20editorial%20streetwear%20lookbook&width=800&height=600&seq=art-09-v2&orientation=landscape',
      link: '/articoli/prodotti-migliori-itaobuy',
    },
    {
      tag: 'GUIDA',
      title: 'Itaobuy Spreadsheet per Italiani: Guida alla Spedizione e ai Costi',
      description: 'Tutto quello che devi sapere su spedizioni verso l\'Italia, costi di consegna, tempi di attesa e come risparmiare sulle spese di trasporto.',
      image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20packing%20tape%20on%20warm%20wooden%20floor%2C%20soft%20morning%20sunlight%2C%20home%20delivery%20aesthetic%2C%20cozy%20unboxing%20anticipation%2C%20warm%20cream%20and%20kraft%20paper%20tones%2C%20editorial%20ecommerce%20style&width=800&height=600&seq=art-10-v2&orientation=landscape',
      link: '/articoli/guida-itaobuy-spreadsheet',
    },
    {
      tag: 'PRODOTTI',
      title: 'Accessori Moda su Itaobuy Spreadsheet: Borse, Cinture e Gioielli',
      description: 'Scopri la selezione di accessori moda disponibili. Dalle borse in pelle alle cinture artigianali, tutto ciò che completa il tuo look.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20and%20minimal%20watch%20displayed%20on%20soft%20linen%20fabric%2C%20gentle%20morning%20light%2C%20luxury%20accessories%20editorial%2C%20warm%20cognac%20and%20cream%20tones%2C%20refined%20masculine%20aesthetic%2C%20quiet%20luxury%20vibe&width=800&height=600&seq=art-11-v2&orientation=landscape',
      link: '/articoli/prodotti-migliori-itaobuy',
    },
    {
      tag: 'SICUREZZA',
      title: 'Protezione Dati Personali: Come Acquistare in Sicurezza con Itaobuy',
      description: 'Guida completa alla protezione dei tuoi dati personali durante gli acquisti. Consigli su password, metodi di pagamento e privacy online.',
      image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20shield%20icon%20on%20a%20clean%20minimal%20desk%2C%20soft%20warm%20ambient%20light%2C%20digital%20privacy%20concept%2C%20modern%20cybersecurity%20aesthetic%2C%20warm%20cream%20and%20soft%20blue-gray%20tones%2C%20trust%20and%20safety%20theme&width=800&height=600&seq=art-12-v2&orientation=landscape',
      link: '/articoli/sicurezza-itaobuy-spreadsheet',
    },
  ];

  return (
    <section id="articoli" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <p className="text-foreground-400 font-label text-sm mb-2">{t('articles.title')}</p>
            <h2 className="font-heading text-3xl md:text-4xl italic text-foreground-950">
              {t('articles.subtitle')}
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            Ogni articolo è scritto in italiano, ottimizzato per la SEO e pensato per aiutarti a fare scelte di acquisto migliori con Itaobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, index) => (
            <Link
              key={index}
              to={article.link}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-500/30 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block bg-accent-100/70 text-accent-700 text-[11px] px-3 py-1 rounded-full font-label mb-3">
                  {article.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug mb-2 group-hover:text-accent-700 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-label text-foreground-800 group-hover:gap-2 transition-all">
                  {t('articles.read_more')}
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}